import { Alert } from '@interstate/components/Alert';
import { Typography } from '@interstate/components/Typography';
import * as dueAtSigningSelectors from '@makemydeal/dr-dash-store/selectors/dueAtSigningSelectors';
import * as dueAtSigningActionCreators from '@makemydeal/dr-dash-store/actions/dueAtSigningActionCreators';
import { useSelector, useDispatch } from 'react-redux';
import { MessagesContainer, smallCloseButtonSx } from '../dealSummary/common/ComponentLabelStyle';

const DueAtSigningMessages = () => {
    const dispatch = useDispatch();
    const infoMessages = useSelector(dueAtSigningSelectors.getInfoMessages);

    const handleDismissMessage = (index: number) => {
        dispatch(dueAtSigningActionCreators.removeDueAtSigningInfoMessage(index));
    };

    if (infoMessages.length === 0) {
        return null;
    }

    return (
        <MessagesContainer data-testid="info-messages">
            {infoMessages.map(({ heading, content }, index) => (
                <Alert
                    key={index}
                    type="info"
                    role="banner"
                    displayCloseButton
                    onCloseClick={() => handleDismissMessage(index)}
                    sx={smallCloseButtonSx}
                >
                    <Typography variant="strong-sm">{heading}</Typography>
                    <Typography variant="body-sm">{content}</Typography>
                </Alert>
            ))}
        </MessagesContainer>
    );
};

export default DueAtSigningMessages;
